import React from 'react';

import './style.sass';

const HomeLinkButton = ({ t, href }) => {
  return (
    <a
      style={{ cursor: 'pointer' }}
      href={href}
      target="_blank"
      className="button-video-link"
      rel="noopener noreferrer"
    >
      <div className="button-video-link-btn">
        <div className="video-link-btn-section-home">
          <p style={{ textAlign: 'center' }}>
            {t('c1do1Black.home.buttons.getDemo.title')}
          </p>
        </div>
      </div>
    </a>
  );
};

export default HomeLinkButton;
